<template>
    <div class="d-flex flex-column overflow-hidden">

        <transition name="router-anim">
            <v-alert v-if="alert" dense type="info" color='success'> {{ $t('provider_dashboard.alert') }} </v-alert>
        </transition>

        <Uploader @saved="uploadCompleted" />

        <div class="mt-n8">

            <v-row>

                <v-col v-if="!loading" class="d-flex justify-center align-center ">

                    <OneDataCardPlus :loading='loading' class="mx-2" :showedData='areas ? areas.total : 0' :text="$t('areas')" icon='mdi-map-marker-radius-outline' />
                   
                    <div v-ripple @click='dialogCity = true' class="pointer">
                        <OneDataCardPlus :loading='loading' class="mx-2 " :showedData='areas ? areas.citiesTotal : 0' :text="$t('provider_dashboard.location_h')" icon='mdi-city' />
                    </div>

                </v-col>

                <v-col v-else class="d-flex justify-center align-center ">

                    <OneDataCardPlusLoad />
                    <OneDataCardPlusLoad />

                </v-col>

            </v-row>

        </div>

        <area-table-data v-if="!loading" :total="areas ? areas.total : 0"  :areas="areas ? areas : []" :provider="provider" :user="user" />

        <v-skeleton-loader v-else type="article, article, article, article" />

        <!-- Modal Cidades -->

        <dialog-cities :cities="areas ? areas.cities : []" :dialogCity="dialogCity" @closeDialog='dialogCity = false' />

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Uploader from '../components/utils/Uploader/Uploader.vue'
import OneDataCardPlus from '../components/utils/OneDataCardPlus'
import OneDataCardPlusLoad from '../components/utils/OneDataCardPlusLoad'
import AreaTableData from '../components/dashAreas/AreaTableData.vue';
import { GET_TABLE_AREAS } from '../../store/mutations';
import DialogCities from '../components/dashAreas/DialogCities.vue';


export default {

    name: 'DashAreas',

    components: { Uploader, OneDataCardPlus, AreaTableData, OneDataCardPlusLoad, DialogCities },

    data() {
        return {

            alert: true,
            loading: false,
            dialogCity: false,

        }
    },
    async mounted() {

        setTimeout(() => this.alert = false, 4000) // Alerta inicial

        if (this.provider._id) {

            this.loading = true

            await this.getAreasById({ page: 1, id: this.provider._id }) 
            
            this.loading = false

        }   

    },


    computed: {

        ...mapGetters({ provider: 'ProviderVuex/provider', areas: 'AreaVuex/areas', user: 'UserVuex/user' }),
    },

    methods: {

        ...mapActions({ getAreasById: `AreaVuex/${GET_TABLE_AREAS}` }),

        async uploadCompleted() {

            this.loading = true

            await this.getAreasById({page: 1, id: this.provider ? this.provider._id : 0 })

            this.loading = false

        },

    },  

}
</script>
<style scoped>

.pointer {

    cursor: pointer;


}

</style>
